import { render, staticRenderFns } from "./PracticeBubble.vue?vue&type=template&id=6ba67615&"
import script from "./PracticeBubble.vue?vue&type=script&lang=ts&"
export * from "./PracticeBubble.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports